import { merge } from 'lodash';

export function arrayToObject<T>(array: T[] | null | undefined): any {
  if (!array) return {};
  return merge({}, ...array);
}
